import Vue from 'vue'
import VueRouter from 'vue-router'


import HomePage from './page/Home.vue'
import LoginPage from './page/Login.vue'
import UploadPage from './components/Upload.vue'
import UploadFilePage from './components/UploadFile.vue'
import UploadLoading from './components/UploadLoading.vue'
import RecordPage from './components/Record.vue'
import VerifyPage from './components/Verify.vue'
import VerifyFilePage from './components/VerifyFile.vue'
import VerifyResultPage from './components/VerifyResult.vue'
import RecordPrint from './page/RecordPrint.vue'
import VerifyReportPrint from './page/VerifyPrint.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    linkActiveClass:'active',
    routes:[
        {
            path:'/',
            name:'login',
            component:LoginPage,
        },{
            path:'/upload',
            name:'upload',
            component:HomePage,
            children:[
                {
                    path:'/',
                    name:'upload',
                    component:UploadPage
                },{
                    path:'/upload/file',
                    name:'uploadFile',
                    component:UploadFilePage
                },{
                    path:'/upload/loading',
                    name:'uploadLoading',
                    component:UploadLoading
                }
            ]
        },{
            path:'/record',
            name:'record',
            component:HomePage,
            children:[
                {
                    path:'/',
                    name:'record',
                    component:RecordPage,
                }
            ]
        },{
            path:'/verify',
            name:'verify',
            component:HomePage,
            children:[
                {
                    path:'/verify',
                    name:'verify',
                    component:VerifyPage
                },{
                    path:'/verify/file',
                    name:'verifyFile',
                    component:VerifyFilePage
                },{
                    path:'/verify/result',
                    name:'verifyResult',
                    component:VerifyResultPage
                }
            ]
        },{
            path:'/prove',
            name:'recordPrint',
            component:RecordPrint,
        },{
            path:'/verifyReport',
            name:'verifyReport',
            component:VerifyReportPrint,
        }
    ]
})

export default router;